import { sprintf, __ } from '@wordpress/i18n';

export const maybeConvertAmount = (amount, currency) => {
	return [
		'BIF',
		'BYR',
		'CLP',
		'DJF',
		'GNF',
		'ISK',
		'JPY',
		'KMF',
		'KRW',
		'PYG',
		'RWF',
		'UGX',
		'VND',
		'VUV',
		'XAF',
		'XAG',
		'XAU',
		'XBA',
		'XBB',
		'XBC',
		'XBD',
		'XDR',
		'XOF',
		'XPD',
		'XPF',
		'XPT',
		'XTS',
	].includes(currency.toUpperCase())
		? amount
		: amount / 100;
};

export const getHumanDiscount = (coupon, currency = 'usd') => {
	if (coupon?.amount_off && currency) {
		return sprintf(
			__('%s off', 'surecart'),
			getFormattedPrice({
				amount: coupon.amount_off,
				currency,
			})
		);
	}

	if (coupon?.percent_off) {
		return sprintf(__('%1d%% off', 'surecart'), coupon.percent_off || 0);
	}

	return '';
};

export const getFormattedPrice = ({ amount, currency = 'usd' }) => {
	const converted = maybeConvertAmount(parseFloat(amount), currency);

	return `${new Intl.NumberFormat(undefined, {
		style: 'currency',
		currency,
	}).format(parseFloat(converted.toFixed(2)))}`;
};

export const formatNumber = (value, currency = '') =>
	new Intl.NumberFormat([], {
		style: 'currency',
		currency: currency.toUpperCase(),
		currencyDisplay: 'symbol',
	}).format(maybeConvertAmount(value, currency.toUpperCase()));

// get the currency symbol for a currency code.
export const getCurrencySymbol = (code = 'usd') => {
	const formattedParts = new Intl.NumberFormat(undefined, {
		style: 'currency',
		currency: code,
	}).formatToParts();
	return formattedParts.find((part) => part.type === 'currency')?.value;
};

export const translate = (key) => {
	const map = {
		day: __('Day', 'surecart'),
		month: __('Month', 'surecart'),
		year: __('Year', 'surecart'),
		never: __('Lifetime', 'surecart'),
		archived: __('Archived', 'surecart'),
		draft: __('Draft', 'surecart'),
		active: __('Active', 'surecart'),
		inactive: __('Inactive', 'surecart'),
		pending: __('Pending', 'surecart'),
		approved: __('Approved', 'surecart'),
		denied: __('Denied', 'surecart'),
		reviewing: __('Reviewing', 'surecart'),
		processing: __('Processing', 'surecart'),
		paid: __('Paid', 'surecart'),
	};
	return map?.[key] || key;
};

export const filterObject = (obj, predicate) =>
	Object.keys(obj)
		.filter((key) => predicate(obj[key]))
		.reduce((res, key) => ((res[key] = obj[key]), res), {});

export const snakeToCamel = (str) =>
	str
		.toLowerCase()
		.replace(/([-_][a-z])/g, (group) =>
			group.toUpperCase().replace('-', '').replace('_', '')
		);

export const camelName = (name) => {
	const camelName = snakeToCamel(name);
	return camelName.charAt(0).toUpperCase() + camelName.toLowerCase().slice(1);
};

export const createErrorString = (error) => {
	const additionalErrors = (error?.additional_errors || [])
		.map((error) => error?.message)
		.filter((n) => n);
	return `${error?.message || __('Something went wrong.', 'surecart')}${
		additionalErrors?.length && ` ${additionalErrors.join('. ')}`
	}`;
};
